<template>
    <form method="post" id="form-save-more-info" @submit.prevent="submit">
        <input type="hidden" name="email" value="<%= email %>">
        <div class="panel-body" style="border-top: none; border-radius: 3px !important;">
            <h4 class="text-center mb-5">Give us a little bit of info</h4>
            <p class="text-center mb-30">so we can set up your environment</p>
            <div class="alert alert-danger" style="display: none"></div>
            <div class="alert alert-success" style="display: none"></div>
            <div class="form-horizontal mb-0">
                <div class="row mb-20">
                    <div class="col-sm-12">
                        <div class="input-group">
                            <span class="input-group-addon"><font-awesome-icon icon="user" /></span>
                            <input name="name"
                                   type="text"
                                   class="form-control"
                                   id="name"
                                   placeholder="Your name"
                                   v-model="name"
                            >
                        </div>
                    </div>
                </div>
                <div class="row mb-20">
                    <div class="col-sm-12">
                        <div class="input-group">
                            <span class="input-group-addon"><font-awesome-icon icon="users" /></span>
                            <input name="company_name"
                                   type="text"
                                   class="form-control"
                                   id="company-name"
                                   placeholder="Company name"
                                   v-model="company"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-footer">
            <div class="">
                <button type="button" class="btn btn-primary w-100" id="submit" @click="submit">
                    <span v-if="!isLoading">Request Demo</span>
                    <pulse-loader :loading="isLoading" color="white" size="5px" />
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {mapGetters} from "vuex";
    import PulseLoader from "vue-spinner/src/PulseLoader";

    export default {
        name: "MoreInfo",
        data() {
            return {
                isLoading: false
            }
        },
        components: {
            PulseLoader
        },
        methods: {
            ...mapGetters({
                getName: 'getName',
                getCompany: 'getCompany',
            }),
            submit() {
                this.isLoading = true;
                this.$store.dispatch('submit', {
                    name: this.name,
                    company: this.company,
                    isSubmitted: 1
                }).then(() => {
                    this.isLoading = false;
                    this.$router.push({name: 'finish'});
                })
            }
        },
        computed: {
            name: {
                get() {
                    return this.getName()
                },
                set(val) {
                    this.$store.commit('SET_NAME', val)
                }
            },
            company: {
                get() {
                    return this.getCompany()
                },
                set(val) {
                    this.$store.commit('SET_COMPANY', val)
                }
            },
        }
    }
</script>

<style scoped>
    .input-group {
        padding-bottom: 10px;
    }
</style>